module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 145.87a9aa33.png";